export var LinkStatus;
(function (LinkStatus) {
    LinkStatus[LinkStatus["CURRENT"] = 1] = "CURRENT";
    LinkStatus[LinkStatus["OBSOLETE"] = 2] = "OBSOLETE";
    LinkStatus[LinkStatus["BLOCKED"] = 3] = "BLOCKED";
    LinkStatus[LinkStatus["CIRCULAR"] = 4] = "CIRCULAR";
    LinkStatus[LinkStatus["BROKEN"] = 5] = "BROKEN";
    LinkStatus[LinkStatus["NOT_SHARED"] = 6] = "NOT_SHARED";
    LinkStatus[LinkStatus["UNKNOWN"] = 8] = "UNKNOWN";
    LinkStatus[LinkStatus["DISABLED"] = 10] = "DISABLED";
    LinkStatus[LinkStatus["BAD_DATA"] = 11] = "BAD_DATA";
})(LinkStatus || (LinkStatus = {}));
//# sourceMappingURL=SheetLink.js.map